module.exports = __webpack_public_path__ + "Roboto-Regular.3cf6adf61054c328b1b0.woff";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/dist/fonts/roboto/Roboto-Regular.woff
// module id = 611
// module chunks = 2